export const countNumberOfCards = (cardsWrapper: HTMLElement): number => {
	if (!cardsWrapper || __IS_SERVER__) {
		return 3;
	}
	const { columnGap, gridTemplateColumns, width } = window.getComputedStyle(cardsWrapper);

	const columnGapNumber = parseInt(columnGap, 10);
	const cardWidth = parseInt(gridTemplateColumns, 10);
	const wrapperWidth = parseInt(width, 10);

	return Math.floor((wrapperWidth + columnGapNumber) / (cardWidth + columnGapNumber)) || 3;
};
